import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { messagingQueryKeys } from '@/modules/messaging/queries/queryKeys';
import { invalidateQuery } from '@/utils/queries';

interface SendDraftMessagesParams {
  messageIds: string[];
}

export const useSendDraftMessagesMutation = () => {
  return useMutation({
    mutationFn: ({ messageIds }: SendDraftMessagesParams) =>
      fetchClient.PUT('/messages/send', {
        body: {
          messageIds,
        },
      }),
    onSettled: () => {
      invalidateQuery(messagingQueryKeys.messages(['Draft']))();
    },
  });
};
